import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { RoleGuard } from './core/guards/role.guard';
import { MarkdownModule } from 'ngx-markdown';
import { importProvidersFrom } from '@angular/core';
import { hasCompanyGuard } from './core/guards/has-company.guard';
import { iframeAuthGuard } from './core/guards/iframe-auth.guard';

export const routes: Routes = [
  {
    path: 'account',
    loadChildren: () =>
      import('./pages/account/account.routes').then((m) => m.ACCOUNT_ROUTES),
    data: { preload: false },
  },
  {
    path: 'marketing',
    loadChildren: () =>
      import('./pages/marketing/marketing.routes').then(
        (m) => m.MARKETING_ROUTES
      ),
    canActivate: [RoleGuard, AuthGuard],
    data: {
      roles: [
        'CanTrackingModuleAccess',
        'CanDocumentationModuleAccess',
        'CanReportModuleAccess',
        'CanEdit',
        'CanShareShipment',
        'CanEditTags',
        'CanDeleteShipment',
        'CanCreateShipment',
        'CanUseSFTP',
        'CanUseComments',
        'CanUseDashboard',
        'CanEditDocument',
      ],
      preload: false,
    },
  },
  {
    path: 'calculator',
    loadChildren: () =>
      import('./pages/calculator/calculator.routes').then(
        (m) => m.CALCULATOR_ROUTES
      ),
    canActivate: [AuthGuard],
    data: { preload: false },
  },
  {
    path: 'reports/:companyId',
    loadChildren: () =>
      import('./pages/reports/reports.routes').then((m) => m.REPORTS_ROUTES),
    canActivate: [AuthGuard, hasCompanyGuard],
    data: { preload: false },
  },
  {
    path: 'reports/embedded/:companyId',
    loadChildren: () =>
      import('./pages/reports/reports.embedded.routes').then(
        (m) => m.REPORTS_EMBEDDED_ROUTES
      ),
    canActivate: [iframeAuthGuard],
    data: { preload: false },
  },
  {
    path: '',
    loadChildren: () =>
      import('./pages/chat-bot/chat-bot.routes').then((m) => m.CHATBOT_ROUTES),
    canActivate: [AuthGuard],
    data: { preload: false },
    providers: [importProvidersFrom(MarkdownModule.forRoot())],
  },
];
